
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useStore } from "../../../stores/store";
import { observer } from "mobx-react-lite";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useTranslation } from "react-i18next";
import { useEditData } from "../../../hooks/useEditData";
import FormLayout from '../../Generic/FormLayout';
import FormInput from '../../Generic/FormInput';
import FormCheckbox from '../../Generic/FormCheckbox';
import { useSetMenu } from "../../../hooks/useSetMenu";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import FormSelect from "../../Generic/FormSelect";
import { useChangePassword } from "../../../hooks/useChangePassword";

const ChangePassword = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { mainStore } = useStore();
  const axiosPrivate = useAxiosPrivate();
  const { t } = useTranslation();

  useSetMenu(mainStore.UserMenuType, mainStore.UserMenuNo);
  const schema = yup.object({
    password: yup
      .string()
      .required(t('requiredField'))
      .max(50, t('maxLength', { max: 50 })),
    confirmPassword: yup
      .string()
      .required(t('requiredField'))
      .max(50, t('maxLength', { max: 50 }))
      .oneOf([yup.ref('password'), null], t('passwordsMustMatch')),
  });

  const { register, handleSubmit, formState: { errors }, setValue } = useForm({ resolver: yupResolver(schema) });
  const onSubmit = data => {
    const formattedData = {
      password: data.password,
      confirmPassword: data.confirmPassword,
    }
    updatePassword(formattedData)
  };

  const additionalDataFetch = async (userData) => {

  };

  const { notFound, updateData } = useEditData(axiosPrivate, "/Users", id, setValue, navigate, additionalDataFetch);
  const updatePassword = useChangePassword(axiosPrivate, "/Users/resetPassword", id, navigate);

  const goToList = () => {
    navigate("/User/List");
  };

  if (notFound) {
    return <div className="not-found-myDiv">
      <div className="not-found-container">
        <div className="not-found-content">
          <h1>{t("pageNotFoundTitle")}</h1>
          <p>{t("noDataWithIdMessage")}</p>
          <button onClick={goToList} className="btn btn-primary">
            {t("goTo") + " " + t("list") + " " + t("users")}
          </button>
        </div>
      </div>
    </div>;
  }

  return (
    <FormLayout title={t("userChangePassword")} onSubmit={handleSubmit(onSubmit)} onCancel={() => navigate(-1)}>
      <FormInput label="user" name="fullName" register={register} errors={errors} colSize={3} disabled={true} required={false} />
      <div className="w-100"></div>
      <FormInput type="password" label="userPassword" name="password" register={register} errors={errors} colSize={5} />
      <FormInput type="password" label="userConfirmPassword" name="confirmPassword" register={register} errors={errors} colSize={5} />
    </FormLayout>
  );
};

export default observer(ChangePassword);